import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import Image from '@segment/matcha/components/Image'

import customerDataFoundationPng from './assets/CustomerDataFoundation.png'
import customerDataFoundationPng2x from './assets/CustomerDataFoundation@2x.png'
import customerDataFoundationWebp from './assets/CustomerDataFoundation.webp'
import customerDataFoundationWebp2x from './assets/CustomerDataFoundation@2x.webp'

import customerDataFoundationMobilePng2x from './assets/CustomerDataFoundationMobile@2x.png'
import customerDataFoundationMobileWebp from './assets/CustomerDataFoundationMobile.webp'
import customerDataFoundationMobileWebp2x from './assets/CustomerDataFoundationMobile@2x.webp'

const CustomerDataFoundationImage = () => {
  const theme = useTheme()
  return (
    <Picture>
      <source
        type="image/webp"
        media={theme.breakpoints.up(`lg`, false)}
        srcSet={`${customerDataFoundationWebp}, ${customerDataFoundationWebp2x} 2x`}
        width="624"
        height="404"
      />
      <source
        media={theme.breakpoints.up(`lg`, false)}
        srcSet={`${customerDataFoundationPng}, ${customerDataFoundationPng2x} 2x`}
        width="624"
        height="404"
      />
      <source
        type="image/webp"
        srcSet={`${customerDataFoundationMobileWebp}, ${customerDataFoundationMobileWebp2x} 2x`}
        width="315"
        height="556"
      />
      <Image
        src={customerDataFoundationMobilePng2x}
        alt="Illustration: Customer data foundation"
        width="315"
        height="556"
        loading="lazy"
      />
    </Picture>
  )
}

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default CustomerDataFoundationImage
